export const AWS_URL = "https://s3-eu-west-1.amazonaws.com/surveyefficiencecell/";
export const MEDIA_DOWNLOAD_URL = process.env.REACT_APP_API + "/api/media/downloadbyurl/";

export const COLOR_ENV = {
  PROD: undefined,
  STAGING: "yellow",
  DEV: "green"
};

export let serverEnv = "PROD";
if (process.env.REACT_APP_API.includes("dev")) serverEnv = "DEV";
if (process.env.REACT_APP_API.includes("staging")) serverEnv = "STAGING";
if (process.env.REACT_APP_API.includes("localhost")) serverEnv = "LOCAL";



// WEBPACK FOOTER //
// src/configs/config.js